import {requestTypeCodes} from './requestTypeCodes';

const requestTypeOptions = [
  {
    id: requestTypeCodes.Estudiantes,
    label: 'Estudiante',
    description: 'Es requerido añadir un estudiante para la solicitud.',
    icon: 'fas fa-user',
  },
  {
    id: requestTypeCodes.DosMasEstudiantes,
    label: 'Dos o Más Estudiantes',
    description:
      'Es requerido seleccionar al menos dos estudiantes para la solicitud. ',
    icon: 'fas fa-user-friends',
  },
  {
    id: requestTypeCodes.Grupo,
    label: 'Grupo',
    description:
      'Es requerido seleccionar un grupo con la misma alternativa de ubicación para la solicitud.',
    icon: 'fas fa-users',
  },
];

export default requestTypeOptions;
